import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Tengo que pasar hambre?',
  a: 'No, el protocolo se enfoca en la densidad nutricional que te mantiene saciado. No se trata de comer menos, sino de comer estratégicamente.'
}, {
  q: '¿Necesito equipo especial?',
  a: 'No, solo comida real que encuentras en cualquier supermercado y 10 minutos de caminata suave al día.'
}, {
  q: '¿Puedo seguir tomando mi café?',
  a: 'Sí, el café negro es un aliado en este proceso y te enseñaremos cómo utilizarlo a tu favor.'
}, {
  q: '¿Es seguro si tomo medicación?',
  a: 'Este plan es 100% nutricional y natural, pero siempre recomendamos mostrar la guía a su médico tratante antes de hacer cambios significativos en su dieta.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-navy-800" data-id="element-32">
      <div className="max-w-3xl mx-auto" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-34">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-35">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-900 border border-navy-700 rounded-xl overflow-hidden" data-id="element-37">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-38">
                <span className="font-bold text-lg text-white" data-id="element-39">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-orange transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-40" />
              </button>

              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-42">
                    <div className="px-6 pb-5 text-gray-400 leading-relaxed border-t border-navy-800 pt-4" data-id="element-43">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}